import { render } from "./Ai247InstanceDetail.vue?vue&type=template&id=661ca813&scoped=true&ts=true"
import script from "./Ai247InstanceDetail.vue?vue&type=script&lang=ts"
export * from "./Ai247InstanceDetail.vue?vue&type=script&lang=ts"

import "./Ai247InstanceDetail.vue?vue&type=style&index=0&id=661ca813&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-661ca813"]])

export default __exports__